"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEST_ABOUT_US_FORM = exports.ABOUT_US_FORM = void 0;
exports.ABOUT_US_FORM = 'https://script.google.com/macros/s/AKfycbxC5hfHbrjAMttFa-7GVa_7FFTaS9T8f6dEwoyU7CQiRlj_FXMN9Et0BzHdrTVyoho/exec';
exports.TEST_ABOUT_US_FORM = 'https://script.google.com/macros/s/AKfycby2a2Qh98UNkDi-jAWPf8bxff89Q-C1q9U2MweX7p-liNc3QRh8Dwsfr5Q3aW0OoGCHDA/exec';
